import { featuresData } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-star-line mr-1"></i>为什么选我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，打造全网最专业的吃瓜平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 border border-background-200/60 rounded-xl p-5 md:p-6 hover:border-background-300/60 transition-colors group cursor-default"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-heading font-bold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}